import { LocalStorage } from '@Config/constants';
import { getObjectFromLocalStorage, setObjectToLocalStorage } from '@Utils/localStorage';
import { generateHistoryArray } from '@Utils/util';

const useAdvertHistory = () => {
  const advertHistory = getObjectFromLocalStorage<string[]>(LocalStorage.lastPreviewedAds) || [];

  return {
    advertHistory,
    addNewIdToHistory: (id: string) => {
      const newArray = generateHistoryArray(advertHistory, id);
      setObjectToLocalStorage(LocalStorage.lastPreviewedAds, newArray);
    },
  };
};

export default useAdvertHistory;
